import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M12.755 8.005a4.75 4.75 0 1 0-9.5 0 4.75 4.75 0 0 0 9.5 0M7.38 4.855a.625.625 0 1 1 1.25 0v2.823l2.14 1.482a.626.626 0 0 1-.711 1.028L7.649 8.52a.63.63 0 0 1-.27-.515zm6.625 3.15a6 6 0 1 1-12 0 6 6 0 0 1 12 0"
    }, null, -1)
  ]))]))
}
export default { render: render }